export default __webpack_public_path__ + "7b23481b73ff9a02e5c32336bee0272e.jpg";